import React, { useState } from 'react'
import { EditOutlined, DeleteOutlined } from '@ant-design/icons'

export const BulkUpdateTableCellActionsWrapper: React.FC<{
  children: React.ReactNode
  isLastColumn: boolean
  totalRows: number
  onDeleteRow: (index: number) => void
  rowIndex: number
  showEditIcon?: boolean
  padding?: string
}> = ({
  children,
  isLastColumn,
  totalRows,
  onDeleteRow,
  rowIndex,
  showEditIcon = false,
  padding = '0',
}) => {
  const [isHovered, setIsHovered] = useState(false)

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        height: '100%',
        padding,
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {children}
      <div
        style={{
          display: 'flex',
          gap: '8px',
          opacity: isHovered ? 1 : 0,
          transition: 'opacity 0.2s ease',
        }}
      >
        {showEditIcon && (
          <EditOutlined
            style={{
              fontSize: '14px',
              color: '#8c8c8c',
            }}
          />
        )}
        {isLastColumn && totalRows > 1 && (
          <DeleteOutlined
            style={{
              fontSize: '14px',
              color: '#ff4d4f',
              cursor: 'pointer',
            }}
            onClick={(e) => {
              e.stopPropagation()
              onDeleteRow(rowIndex)
            }}
          />
        )}
      </div>
    </div>
  )
}
